// extracted by mini-css-extract-plugin
export var compactFilters = "_g2-4";
export var detailImage = "_g2-1";
export var dropdownContainer = "_g2-2";
export var imageContainer = "_g2-0";
export var selectedCard = "_g2-3";